<script>

    import { onMount, onDestroy } from 'svelte';
    import { browser } from '$app/environment';
    import { page } from "$app/stores";
    import Top from "$lib/components/menuer/topbar_signup.svelte";
    import Megamenu from "$lib/components/menuer/megamenu2.svelte";
    import PageHeader from '$lib/components/pageheader.svelte';
    import Footer from "$lib/components/footer.svelte";
    import Opskriftpreview from "$lib/components/opskriftpreview.svelte";
    import { afterNavigate } from '$app/navigation';

    import dayjs from 'dayjs';
    import 'dayjs/locale/da';
    dayjs.locale('da');

    /** @type {import('./$types').PageData} */
    export let data;

    //console.log(data);

    function nav_back() {
        if (browser) window.history.back();
    }

    let Page = $page.data.page !== undefined ? $page.data.page : 1;

    let Paging = true;
    let PageSize = 12;
    let PageNumber = 1;
    let PageInput = PageNumber;
    $: NumberOfPages = Math.ceil(data.Opskrifter.length / PageSize);


    $: Paging = NumberOfPages > 1 ? true : false;

    $: PageInput = PageNumber;

    /**
	 * @type {Document | null}
	 */
     let loadedDocument = null;
   
    let PageRecipes =  [];
    let CurrentPage = 1;

    const SetCurrentPage = (x) => CurrentPage = x;

    $: if (loadedDocument != null) {
        let x = CurrentPage;
        x = Math.min(Math.max(x, 1), NumberOfPages)
        if(x <= NumberOfPages) {
            PageNumber = x;
            let sliceStart = x === 1 ? 0 : (x * PageSize - (PageSize));
            let sliceEnd = sliceStart + PageSize;
            PageRecipes  = data.Opskrifter.slice(sliceStart, sliceEnd);
            PageRecipes = PageRecipes;
        }
    }

    afterNavigate(() => CurrentPage = 1)

    const keypress = (event) => {
        switch (event.key) {

      case "Enter":
            SetCurrentPage(PageInput);
        break;

      default:
        return; // Quit when this doesn't handle the key event.
        }
    }

    
    onMount(async () => { 
        if(browser) {
            loadedDocument = document;
            SetCurrentPage(1);
        }
    });

</script>


<svelte:head>
        
<title>{data.Opskrifter[0].userNamePublic}s opskrifter</title>
<meta name="description" content="" />
<meta name="robots" content="nofollow,noindex" />
<meta property="og:title" content="" />
<meta property="og:description" content="" />

</svelte:head>

<Top User="{data.user}" />
<Megamenu User="{data.user}" />



<div class="container-fluid">

{#if data.Opskrifter.length > 0}


<PageHeader PageName={"Bruger opskrifter"} Icon={"fa-regular fa-circle-user fa-lg fav-icon"} IconColor={"grey"} />


<div class="row mt-3 mt-xl-4 mb-3 mb-xl-4">
    <!-- <div class="col-12">
        <button type="button" on:click={nav_back}>Tilbage</button>
    </div> -->
    <div class="col-12 text-center">


            <h2 class="mt-2">Opskrifter indtastet af</h2>
            {#if data.Opskrifter[0].avatar !== undefined && data.Opskrifter[0].avatar !== null}
            <div class="text-center">
                 <img class="profilbillede mt-2 mb-2 d-inline-block" src="{data.Opskrifter[0].avatar}" alt="Profilbillede" />
            </div>
                 <h1>{data.Opskrifter[0].userNamePublic}</h1>
            {:else}
                <h1>{data.Opskrifter[0].userNamePublic}</h1>
            {/if}
            <small class="d-block my-3">Bruger siden: <strong>{dayjs(data.Opskrifter[0].BrugerSiden).format("D. MMMM YYYY")}</strong></small>

    </div>
</div>



{#if Paging && data.Opskrifter.length > 0}


<div class="row justify-content-center mb-4">

    <div class="col-auto d-flex align-items-center order-2 order-md-1">
        {#if PageNumber > 2}
            <a href="?p={1}" on:click|preventDefault={() => SetCurrentPage(1)} class="button">
                <i class="fa-solid fa-angles-left"></i>
            </a>
        {:else}
        {#if PageNumber == 1}
                <a href="#" class="button disabled">
                    <i class="fa-solid fa-angles-left"></i>
                </a>
             {:else}
                <a href="?p={1}" on:click|preventDefault={() => SetCurrentPage(1)} class="button">
                    <i class="fa-solid fa-angles-left"></i>
                </a>
        {/if}
     {/if}
    </div>

    <div class="col-auto d-flex align-items-center order-3 order-md-2">
        {#if PageNumber > 1}
            <a href="?p={PageNumber - 1}" on:click|preventDefault={() => SetCurrentPage(PageNumber - 1)} class="button">
                <i class="fa-solid fa-angle-left"></i>
            </a>
        {:else}
            <a href="#" class="button disabled">
                <i class="fa-solid fa-angle-left"></i>
            </a>
    {/if}
    </div>


    <div class="col-12 col-md-auto text-center order-1 order-md-3">
        <div class="d-inline-block pb-2 pb-md-0">
            <div class="d-flex justify-items center align-items-center ps-2 pe-2 ps-md-2 pe-md-3 ps-xl-4 pe-xl-4">
                <span>Side</span>
                <input on:keypress={keypress} bind:value={PageInput} step="1" min="1" max="{NumberOfPages}" on:blur={() => SetCurrentPage(PageInput)} class="input-paginering ms-2 me-2" type="number" width="20" />
                <span>af {NumberOfPages}</span>
            </div>   
        </div>         
    </div>


    <div class="col-auto d-flex align-items-center order-4 order-md-5">
        {#if PageNumber < NumberOfPages}
            <a href="?p={PageNumber + 1}" on:click|preventDefault={() => SetCurrentPage(PageNumber + 1)} class="button">
                <i class="fa-solid fa-angle-right"></i>
            </a>
        {:else}
            <a href="#" class="button disabled">
                <i class="fa-solid fa-angle-right"></i>
            </a>
        {/if}
    </div>

    <div class="col-auto d-flex align-items-center order-5 order-md-6">
        {#if PageNumber < NumberOfPages - 1}
            <a href="?p={NumberOfPages}" on:click|preventDefault={() => SetCurrentPage(NumberOfPages)} class="button">
                <i class="fa-solid fa-angles-right"></i>
            </a>
        {:else}
            {#if PageNumber == NumberOfPages}
                <a href="#" class="button disabled">
                    <i class="fa-solid fa-angles-right"></i>
                </a>
                {:else}
                <a href="?p={NumberOfPages}" on:click|preventDefault={() => SetCurrentPage(NumberOfPages)} class="button">
                    <i class="fa-solid fa-angles-right"></i>
                </a>
            {/if}
     {/if}
    </div>


</div>


{/if}



<div class="row justify-content-center">


    




    {#if data.Opskrifter !== null && data.Opskrifter !== undefined && data.Opskrifter.length > 0}
        {#each PageRecipes as Opskrift}
        <div class="col-12 col-sm-6 col-md-4 col-xl-3 col-xxl-2 mb-2">
            <Opskriftpreview Opskriften="{Opskrift}" ShowDate={true} ShowFavouriteSymbol={true} User="{data.user}" ShowOwnerName={false} />
        </div>
        {/each}
    {/if}


    {#if Paging && data.Opskrifter.length > 0}
        <div class="col-12">
         <div class="row mt-4 mb-5">
            <div class="col-12 text-center">
                <ul class="paginering">
                {#each {length: NumberOfPages} as _, i}
                    <li>
                        <a href="?p={i + 1}" on:click|preventDefault={() => SetCurrentPage(i + 1)} class="button {PageNumber === i + 1 ? 'active':''}">{i + 1}</a>
                        <!-- <a href="?p={i+1}" on:click={() => Page = i + 1} class="button {Page === i + 1 ? 'active':''}">{i + 1}</a> -->
                        <!-- <button on:click={() => Page = i + 1} class="button {Page === i + 1 ? 'active':''}">{i + 1}</button> -->
                    </li>
                {/each}
                </ul>
            </div>
         </div>
        </div>
    {/if}




</div>


{:else}
     <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-xl-8">
            <h5>Der er desværre ingen af brugerens opskrifter som du kan se</h5>
        </div>
     </div>
{/if}


</div>



<Footer User="{data.user}" />


<style lang="scss">

@use './static/styles/colors';

img.profilbillede {
    max-height: 60px;
}

        h1 {
            font-family: "Roboto Slab", serif;
            font-size: clamp(1.9rem, 3vw, 2.2rem);
            .parent-kat {
                color: colors.$color-kat-parent;
            }
        }

        h2 {
            font-family: 'Roboto Condensed', sans-serif;
            font-size: clamp(1.2rem, 3vw, 1.4rem);
            font-weight: normal;
            max-width: 800px;
            margin: 0 auto;
        }

        h3 {
            font-size: 1rem;
            color: #777;
            letter-spacing: 0.2rem;
        }


        ul.paginering {
            margin: 0;
            padding: 0; 
            list-style: none;
            li {
                display: inline-block;
                padding: 0 3px;
                button, a.button {
                    border: none;
                    text-decoration: none;
                    background: #eee;
                    color: #222;
                    display: block;
                    border-radius: 15px;
                    width: 30px; height: 30px;
                    line-height: 26px;
                    font-size: 0.9rem;
                    &:hover {
                        background: #ccc;
                    }
                    &.active {
                        background: colors.$primary-color;
                        color: white;
                    }
                    &.disabled {
                        color: #ccc;
                        &:hover{
                            background: #eee;
                        }
                    }
                }
            }
        }


        button {
            &.btn-paginering {
                background: none !important;
                border: none;
                &:hover{
                    color: colors.$primary-color;
                }
            }

        }

        input.input-paginering {
            border: 1px solid #bbb;
            border-radius: 5px;
            width: 50px;
            text-align: center;
            background: lighten(colors.$primary-color,49%);
        }
        
        input[type="number"] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
}
        input[type=number]::-webkit-inner-spin-button,
            input[type=number]::-webkit-outer-spin-button {
                -webkit-appearance: none;
            }

</style>